import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'auth/login'
    },
    {
        path: 'sso/handoff',
        loadComponent: () => import('./handoff/handoff.component'),
    },
    {
        path: 'auth',
        canActivate: [authGuard],
        loadComponent: () => import('./auth/auth.component'),
        title: 'RÜM',
        children: [
            {
                path: '',
                redirectTo: 'login',
                pathMatch: 'full'
            },
            {
                path: 'login',
                loadComponent: () => import('./auth/login/login.component'),
                title: 'RÜM - Login'
            },
            {
                path: 'recover',
                loadComponent: () => import('./auth/recover/recover.component'),
                title: 'RÜM - Recuperar Contraseña'
            },
            {
                path: 'reset-password',
                loadComponent: () => import('./auth/reset/reset.component'),
                title: 'RÜM - Restablecer Contraseña'
            }
        ]
    },
    {
        path: 'auth/sent-recover',
        loadComponent: () => import('./auth/sent-recover/sent-recover.component'),
        title: 'RÜM - Correo enviado'
    },
    {
        path: 'dashboard',
        canActivate: [authGuard],
        loadComponent: () => import('./dashboard/dashboard.component'),
        data: { breadcrumb: 'Inicio' },
        children: [
            {
                path: '',
                redirectTo: 'inicio', pathMatch: 'full'
            },
            {
                path: 'comentarios',
                loadComponent: () => import('./dashboard/comentarios/comentarios.component'),
                title: 'Comentarios y opiniones',
                data: { breadcrumb: 'Comentarios y opiniones' },
            },
            {
                path: 'configuracion',
                loadComponent: () => import('./dashboard/configuracion/configuracion.component'),
                title: 'Configuración',
                data: { breadcrumb: 'Configuración' },
                children: [
                    {
                        path: '',
                        redirectTo: 'anfitrion',
                        pathMatch: 'full'
                    },
                    {
                        path: 'anfitrion',
                        loadComponent: () => import('./dashboard/configuracion/informacion-anfitrion/informacion-anfitrion.component'),
                        data: { breadcrumb: 'Información anfitrion' }
                    },
                    {
                        path: 'facturacion',
                        loadComponent: () => import('./dashboard/configuracion/facturacion/facturacion.component'),
                        data: { breadcrumb: 'Facturación' }
                    },
                    {
                        path: 'pagos',
                        loadComponent: () => import('./dashboard/configuracion/pagos/pagos.component'),
                        data: { breadcrumb: 'Pagos' }
                    },
                    {
                        path: 'politicas',
                        loadComponent: () => import('./dashboard/configuracion/politicas/politicas.component'),
                        data: { breadcrumb: 'Políticas' }
                    },
                    {
                        path: 'preferencias',
                        loadComponent: () => import('./dashboard/configuracion/preferencias/preferencias.component'),
                        data: { breadcrumb: 'Preferencias' }
                    },
                    {
                        path: 'usuarios',
                        loadComponent: () => import('./dashboard/configuracion/usuarios/usuarios.component'),
                        data: { breadcrumb: 'Usuarios' }
                    },
                ]
            },
            {
                path: 'disponibilidad',
                loadComponent: () => import('./dashboard/disponibilidad/disponibilidad.component'),
                title: 'Disponibilidad',
                data: { breadcrumb: 'Disponibilidad' },
            },
            {
                path: 'establecimientos',
                loadComponent: () => import('./dashboard/establecimientos/establecimientos.component'),
                title: 'RÜM - Establecimientos',
                data: { breadcrumb: 'Establecimientos' },
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./dashboard/establecimientos/establecimientos-home/establecimientos-home.component'),
                        title: 'Lista establecimientos',
                        data: { breadcrumb: null },
                    },
                    {
                        path: 'detalle/:id',
                        loadComponent: () => import('./dashboard/establecimientos/establecimientos-detalle/establecimientos-detalle.component'),
                        title: 'Detalles',
                        data: { breadcrumb: 'Detalle' }
                    },
                ]
            },
            {
                path: 'inicio',
                loadComponent: () => import('./dashboard/inicio/inicio.component'),
                title: 'RÜM - Inicio',
            },
            {
                path: 'reportes',
                loadComponent: () => import('./dashboard/reportes/reportes.component'),
                title: 'RÜM - Reportes',
                data: { breadcrumb: 'Reportes' },
            },
            {
                path: 'reservas',
                loadComponent: () => import('./dashboard/reservas/reservas.component'),
                title: 'RÜM - Reservas',
                data: { breadcrumb: 'Reservas' },
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./dashboard/reservas/reservas-home/reservas-home.component'),
                        data: { breadcrumb: null },
                    },
                    {
                        path: 'detalle/:id',
                        loadComponent: () => import('./dashboard/reservas/detalle-reserva/detalle-reserva.component'),
                        data: { breadcrumb: 'Detalle' }
                    },
                    {
                        path: 'nueva',
                        loadComponent: () => import('./dashboard/reservas/nueva-reserva/nueva-reserva.component'),
                        data: { breadcrumb: 'Nueva Reserva' }
                    },
                    {
                        path: 'calendario',
                        loadComponent: () => import('./dashboard/reservas/disponibilidad/disponibilidad.component'),
                        data: { breadcrumb: 'Calendario' }
                    },
                    {
                        path: 'disponibilidad',
                        loadComponent: () => import('./dashboard/reservas/disponibilidad/disponibilidad.component'),
                        data: { breadcrumb: 'Detalle' }
                    },
                ]
            },
            {
                path: 'soporte',
                loadComponent: () => import('./dashboard/soporte/soporte.component'),
                title: 'Soporte',
                data: { breadcrumb: 'Soporte' },
                children: [
                    {
                        path: '',
                        redirectTo: 'ayuda',
                        pathMatch: 'full'
                    },
                    {
                        path: 'ayuda',
                        loadComponent: () => import('./dashboard/soporte/ayuda/ayuda.component'),
                        data: { breadcrumb: 'Centro de ayuda' }
                    },
                    {
                        path: 'reportar-incidencia',
                        loadComponent: () => import('./dashboard/soporte/reportar-incidencia/reportar-incidencia.component'),
                        data: { breadcrumb: 'Reportar incidencia' }
                    },
                    {
                        path: 'historial-incidencias',
                        loadComponent: () => import('./dashboard/soporte/historial-incidencias/historial-incidencias.component'),
                        data: { breadcrumb: 'Historial de incidencias' }
                    },
                    {
                        path: 'documentacion',
                        loadComponent: () => import('./dashboard/soporte/documentacion/documentacion.component'),
                        data: { breadcrumb: 'Documentacion y tutoriales' }
                    },
                ]
            },
        ]
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'auth/login',
    }
];